/*
 * Copyright (c) 2021/5/16 上午2:21
 * Author：HoTeas
 */


import {createRouter, createWebHashHistory} from "vue-router"
// 2. 定义一些路由
// 每个路由都需要映射到一个组件。
const routes = [
    {
        path: '/center',
        name: "center",
        component: () => import('@/views/InfoEdit/Center.vue'),
    },

    {
        path: '/',
        redirect: "/home",
    },
    // {
    //     path: '/chat',
    //     name: "Chat",
    //     component: () => import('@/views/Chat/Chat'),
    // },
    {
        path: '/goods/info',
        name: "Goods",
        component: () => import('@/views/Goods/Info.vue'),
    },
    {
        path: '/act/info',
        name: "Act",
        component: () => import('@/views/Act/Info.vue'),
    },
    {
        path: '/pay',
        name: "pay",
        component: () => import('@/views/Pay/pay'),
    },
    {
        path: '/vip',
        name: "vip",
        component: () => import('@/views/Vip/vip'),
    },
    {
        path: '/share',
        name: "share",
        component: () => import('@/views/Share/share'),
    },
    {
        path: '/word',
        name: "word",
        component: () => import('@/views/Chat/word'),
    },
    {
        path: '/infoedit',
        name: "infoedit",
        component: () => import('@/views/InfoEdit/InfoEdit'),
    },

    {
        path: '/order',
        name: "order",
        component: () => import('@/views/Order/order'),
    },

    {
        path: '/redeem',
        name: "redeem",
        component: () => import('@/views/Redeem/redeem.vue'),
    },

    {
        path: '/redeem/info',
        name: "redeeminfo",
        component: () => import('@/views/Redeem/Info.vue'),
    },

    {
        path: '/order/info',
        name: "orderinfo",
        component: () => import('@/views/Order/Info.vue'),
    },
    {
        path: '/bills',
        name: "bills",
        component: () => import('@/views/Bills/bills.vue'),
    },
    {
        path: '/bills/info',
        name: "billsinfo",
        component: () => import('@/views/Bills/Info.vue'),
    },
    {
        path: '/read',
        name: "read",
        component: () => import('@/views/Read/read'),
    },
    // {
    //     path: '/movie',
    //     name: "movie",
    //     component: () => import('@/views/movie/movie.vue'),
    // },
    {
        path: '/read/info',
        name: "readInfo",
        component: () => import('@/views/Read/info.vue'),
    },
    {
        path: '/credit',
        name: "credit",
        component: () => import('@/views/Credit/credit.vue'),
    },
    {
        path: '/withdraw',
        name: "withdraw",
        component: () => import('@/views/Withdraw/info.vue'),
    },
    {
        path: '/home',
        name: "home",
        component: () => import('@/views/Home/Home'),
    },
    {
        path: '/Login',
        name: "Login",
        component: () => import('@/views/Home/Login'),
    },
]

// 3. 创建路由实例并传递 `routes` 配置
// 你可以在这里输入更多的配置，但我们在这里
// 暂时保持简单
export const router = new createRouter({
    // 4. 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
    history: createWebHashHistory(),
    routes, // `routes: routes` 的缩写
})


router.beforeEach((to, from, next) => {

        // if (to.path === "/") {
        // }
        to.meta.key = to.fullPath
        next()

    }
)